module.exports = __webpack_public_path__ + "img/traitement5.26c1c2aa.jpg";